import React from "react";
import MyOrganizations from "./myOrganizations";

class MyOrganizationsParent extends React.Component {
  render() {
    return <MyOrganizations />;
  }
}
export default MyOrganizationsParent;
